export default function setToggle(curToggle, curLabel, payloadLabel) {
  if (!curToggle) return 'ASC';
  if (curLabel === payloadLabel) {
    let undefinedValue;
    return curToggle === 'ASC' ? 'DESC' : undefinedValue;
  }
  return 'ASC';
}
